"use strict";
/**
 * @packageDocumentation
 * @module Logger.Constants
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.toLevel = exports.levels = exports.silly = exports.debug = exports.info = exports.warn = exports.error = exports.silent = void 0;
var helper_1 = require("@kcutils/helper");
var LoggerLevel_1 = require("../models/logger/LoggerLevel");
exports.silent = new LoggerLevel_1.LoggerLevel(0, "silent", helper_1.stream.null);
exports.error = new LoggerLevel_1.LoggerLevel(1, "error", process.stderr);
exports.warn = new LoggerLevel_1.LoggerLevel(2, "warn", process.stderr);
exports.info = new LoggerLevel_1.LoggerLevel(3, "info", process.stdout);
exports.debug = new LoggerLevel_1.LoggerLevel(4, "debug", process.stdout);
exports.silly = new LoggerLevel_1.LoggerLevel(5, "silly", process.stdout);
var _levels = new Map([
    ["silent", exports.silent],
    ["error", exports.error],
    ["warn", exports.warn],
    ["info", exports.info],
    ["debug", exports.debug],
    ["silly", exports.silly],
]);
exports.levels = Array.from(_levels.values());
var toLevel = function (level, def) {
    if (def === void 0) { def = exports.info; }
    if (_levels.has(level))
        return _levels.get(level);
    else
        return def;
};
exports.toLevel = toLevel;
//# sourceMappingURL=levels.js.map